import { SOFTWARE_PRODUCTS, MOBILEPOD } from "./services"

const menuItems = projects =>
  projects.map(project => ({
    id: project.to,
    label: project.title,
    to: project.to,
  }))

export const MENUS = [
  {
    id: "software",
    label: "Software",
    to: "/software",
    children: [
      ...menuItems(SOFTWARE_PRODUCTS),
      {
        id: "customsoftware",
        label: "APP & Software Personalizzati",
        to: "/software/custom-software",
      },
    ],
  },
  {
    id: "networks",
    label: "Infrastrutture reti",
    to: "/infrastrutture-reti",
    children: [
      ...menuItems([MOBILEPOD]),
      {
        id: "infrastrutture-reti",
        label: "Infrastrutture reti",
        to: "/infrastrutture-reti",
      },
    ],
  },
  {
    id: "entertainment",
    label: "Entertainment",
    to: "/entertainment",
    children: [
      {
        id: "produzione",
        label: "Produzione",
        to: "/entertainment/produzione",
      },
      {
        id: "artistica",
        label: "Direzione Artistica",
        to: "/entertainment/artistica",
      },
      {
        id: "tecnica",
        label: "Direzione Tecnica",
        to: "/entertainment/tecnica",
      },
      {
        id: "segreteria",
        label: "Segreteria Organizzativa",
        to: "/entertainment/segreteria",
      },
      {
        id: "allestimenti",
        label: "Allestimenti",
        to: "/entertainment/allestimenti",
      },
      {
        id: "cinemaspottv",
        label: "Cinema, Spot & TV",
        to: "/entertainment/cinemaspottv",
      },
    ],
  },
  { id: "caseStudy", label: "Case Study", to: "/case-study" },
  { id: "news", label: "News", to: "/news" },
  { id: "aboutUs", label: "Chi Siamo", to: "/about-us" },
  { id: "contacts", label: "Contatti", to: "/contacts" },
]
